import { useEffect } from "react";
import TableGeneric from "../../../compartidos/abms/TableGeneric";
import { useTotemBasic } from "../../../../hooks/useCases/useTotemBasic";
import { useSelector } from "react-redux";
import { Button, Grid, Paper } from "@material-ui/core";
import { validarSoloUnPermiso } from "../../../../helpers/permisos";
import { TOTEM_BASIC_PERMISOS } from "../../../../utils/permisos";

export const BoxesTomados = () => {
    const { boxes } = useSelector((state) => state.totemBasic)
    const { idUsuario, permisos: permisosUser } = useSelector((state) => state.auth);
    const { get, update } = useTotemBasic()
    useEffect(() => get.boxes(), [])
    const permisoParaLiberarOtros = validarSoloUnPermiso(permisosUser, TOTEM_BASIC_PERMISOS.ADMINISTRAR.LIBERAR_BOXES)

  return (
    <Grid container justify="center" >
      <Grid item xs={5} component={Paper}>
        <TableGeneric
          data={boxes}
          tituloSinResultado={"Todos los Boxes se encuentran Tomados / No Existen"}
          align="center"
          columns={[
            {
              label: "Box",
              id: "descripcion",
            },
            {
              label: "",
              customBody: (item) =>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={() => item.idUsuarioTomado === idUsuario || (permisoParaLiberarOtros && item.idUsuarioTomado) ? update.liberarBox({ idBox: item.id }, () => get.boxes()) : update.tomarBox({ idBox: item.id }, () => get.boxes())}
                  disabled={!permisoParaLiberarOtros && (boxes.some(box => box.idUsuarioTomado === idUsuario) && item.idUsuarioTomado !== idUsuario)}>
                  {item.idUsuarioTomado === idUsuario || (permisoParaLiberarOtros && item.idUsuarioTomado) ? "LIBERAR" : "TOMAR"}
                </Button>,
            },
          ]}
        />
      </Grid>
    </Grid>
  )
}
